import merge from 'lodash/merge'
import React from 'react'
import { fetch as fetchCore } from '@ztechapps/common.utils'
import isEmpty from 'lodash/isEmpty'

export type UseFetchOutput = [(args?: unknown) => Promise<{ error: any } | any>, { error: unknown; loading: boolean }]

export type FetchHandlingOptions = {
  raw?: boolean
  fetch?: any
}
/**
 * A common hook for fetch URL, it wraps the Utils.fetch but included the loading and error states
 * @param url - the url that will be called
 * @param options -  fetch options that will be used
 * @param raw - setting the to true, will the raw response from the fetch
 * @param fetch - the fetch implementation that will be used
 * @returns an array, with [function, {error, loading}] - include the states changes for the results
 */
export const useFetch = (url: string, options?: RequestInit, { raw = false, fetch = fetchCore }: FetchHandlingOptions = {}): UseFetchOutput => {
  const [error, setError] = React.useState<any>(null)
  const [loading, setLoading] = React.useState(false)

  options = merge(
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    },
    options
  )

  const fetchNow = async (args: unknown = {}) => {
    try {
      setLoading(true)

      //merge the new options
      const finalOptions: RequestInit = !isEmpty(args)
        ? merge(options, {
            body: JSON.stringify(args),
          })
        : options

      const fetchResult = await fetch(url, finalOptions, { lean: raw })

      //rethrow the if there is
      const { error } = fetchResult || {}
      if (error) {
        throw error
      }

      //just return the result of registration
      return fetchResult
    } catch (e) {
      setError(e)
      //return also teh error object
      return { error: e }
    } finally {
      setLoading(false)
    }
  }

  return [fetchNow, { error, loading }]
}
